import React, { useEffect, useState, useMemo } from 'react';

import { useAdmins } from '../../hooks/admins';
import { loadMasterAdmin } from '../../core/services/admin';
import { FieldGroup, Separator, Loading } from '../../components';

export function MasterAdmin({
  user,
  setMasterAdmin,
  masterAdminUpdated,
}) {
  const [loading, setLoading] = useState(true);
  const { admins } = useAdmins();
  const [currentMasterAdmin, setCurrentMasterAdmin] = useState(null);

  useEffect(() => {
    loadMasterAdmin((theMasterAdmin) => {
      setCurrentMasterAdmin(theMasterAdmin);
      setLoading(false);
    });
  }, [masterAdminUpdated]);

  const options = useMemo(() => {
    return admins.map((admin) => ({
      id: admin.id,
      name: `${admin.first_name} ${admin.last_name} (${admin.email})`,
    }));
  }, [admins]);

  return (
    <>
      <Separator />

      <h3>Master Admin</h3>

      {loading && <Loading type="small" />}

      {!loading && (!currentMasterAdmin || !!user.is_master_admin) && (
        <div className="mt-3">
          <FieldGroup
            label="Master Admin"
            name="master_admin"
            type="select"
            options={options}
            defaultValue={options.find((option) => option.id === currentMasterAdmin?.id)}
            onChange={(newMasterAdmin) => setMasterAdmin(newMasterAdmin)}
          />
        </div>
      )}

      {!loading && currentMasterAdmin && !user.is_master_admin && (
        <div className="mt-3">
          <p>The master admin is <strong>
            {currentMasterAdmin?.first_name} {currentMasterAdmin?.last_name} ({currentMasterAdmin?.email})
          </strong></p>
        </div>
      )}
    </>
  )
};
